import React from 'react';
import { Loader2, Mail, Phone, Sparkles } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import WalkinSection from './WalkinSection';

/** Contact lookup — phone or email autofills known patients. */
export default function WalkinContactSection({ form }) {
  const {
    pPhone, setPPhone, pEmail, setPEmail, setPhoneTouched,
    phoneShowError, phoneErrMsg, searching, autofillNote,
  } = form;

  return (
    <WalkinSection
      step={1}
      title="Find the patient"
      hint="Enter mobile or email — if we already have them, details fill in automatically."
      testId="walkin-contact-section"
    >
      <div className="rounded-xl border border-sky-200 bg-sky-50/70 px-3 py-2.5 flex gap-2 text-[12px] text-sky-900">
        <Sparkles className="h-4 w-4 shrink-0 text-sky-600 mt-0.5" />
        <p>
          Walk-in only: looking up an existing phone or email loads name, age, gender and
          patient number so you do not re-type. New visitors stay on a blank form.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label className="flex items-center gap-1.5 text-[#071B34]">
            <Phone className="h-3.5 w-3.5 text-[#F15A22]" /> Mobile number *
          </Label>
          <div className="relative">
            <Input
              value={pPhone}
              onChange={(e) => setPPhone(e.target.value)}
              onBlur={() => setPhoneTouched(true)}
              placeholder="10-digit Indian mobile"
              inputMode="tel"
              maxLength={16}
              autoComplete="off"
              aria-invalid={phoneShowError || undefined}
              className={phoneShowError ? 'border-red-500 focus-visible:ring-red-500' : ''}
              data-testid="rec-pphone"
            />
            {searching && (
              <Loader2 className="absolute right-2.5 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-[#9AADBE]" />
            )}
          </div>
          {phoneShowError && (
            <p className="text-[11px] text-red-600" data-testid="rec-pphone-error">{phoneErrMsg}</p>
          )}
        </div>
        <div className="space-y-1.5">
          <Label className="flex items-center gap-1.5 text-[#071B34]">
            <Mail className="h-3.5 w-3.5 text-[#F15A22]" /> Email
          </Label>
          <Input
            type="email"
            value={pEmail}
            onChange={(e) => setPEmail(e.target.value)}
            placeholder="name@example.com (optional — used for queue email)"
            autoComplete="off"
            data-testid="rec-pemail"
          />
          <p className="text-[10px] text-[#5A6B7C]">Queue number email is sent here after triage.</p>
        </div>
      </div>
      {autofillNote ? (
        <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-[12px] text-emerald-900 font-medium"
          data-testid="walkin-autofill-note">
          {autofillNote}
        </div>
      ) : null}
    </WalkinSection>
  );
}
